import { createFileRoute, redirect } from '@tanstack/react-router';

// The campaign list moved into the Connect page; old bookmarks still land.
export const Route = createFileRoute('/admin/campaigns/')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  beforeLoad: () => {
    throw redirect({ to: '/admin/connect/', search: { tab: 'campaigns' } });
  },
});
